export const LIST_SUMMARY_GENERATOR_REQUEST = 'LIST_SUMMARY_GENERATOR_REQUEST'
export const LIST_SUMMARY_GENERATOR_SUCCESS = 'LIST_SUMMARY_GENERATOR_SUCCESS'
export const LIST_SUMMARY_GENERATOR_FAIL = 'LIST_SUMMARY_GENERATOR_FAIL'

export const CREATE_SUMMARY_GENERATOR_REQUEST = 'CREATE_SUMMARY_GENERATOR_REQUEST'
export const CREATE_SUMMARY_GENERATOR_SUCCESS = 'CREATE_SUMMARY_GENERATOR_SUCCESS'
export const CREATE_SUMMARY_GENERATOR_FAIL = 'CREATE_SUMMARY_GENERATOR_FAIL'

export const DETAIL_SUMMARY_GENERATOR_REQUEST = 'DETAIL_SUMMARY_GENERATOR_REQUEST'
export const DETAIL_SUMMARY_GENERATOR_SUCCESS = 'DETAIL_SUMMARY_GENERATOR_SUCCESS'
export const DETAIL_SUMMARY_GENERATOR_FAIL = 'DETAIL_SUMMARY_GENERATOR_FAIL'

export const UPDATE_SUMMARY_GENERATOR_REQUEST = 'UPDATE_SUMMARY_GENERATOR_REQUEST'
export const UPDATE_SUMMARY_GENERATOR_SUCCESS = 'UPDATE_SUMMARY_GENERATOR_SUCCESS'
export const UPDATE_SUMMARY_GENERATOR_FAIL = 'UPDATE_SUMMARY_GENERATOR_FAIL'

export const DELETE_SUMMARY_GENERATOR_REQUEST = 'DELETE_SUMMARY_GENERATOR_REQUEST'
export const DELETE_SUMMARY_GENERATOR_SUCCESS = 'DELETE_SUMMARY_GENERATOR_SUCCESS'
export const DELETE_SUMMARY_GENERATOR_FAIL = 'DELETE_SUMMARY_GENERATOR_FAIL'

export const DUPLICATE_SUMMARY_GENERATOR_REQUEST = 'DUPLICATE_SUMMARY_GENERATOR_REQUEST'
export const DUPLICATE_SUMMARY_GENERATOR_SUCCESS = 'DUPLICATE_SUMMARY_GENERATOR_SUCCESS'
export const DUPLICATE_SUMMARY_GENERATOR_FAIL = 'DUPLICATE_SUMMARY_GENERATOR_FAIL'

export const POSITION_SUMMARY_GENERATOR_REQUEST = 'POSITION_SUMMARY_GENERATOR_REQUEST'
export const POSITION_SUMMARY_GENERATOR_SUCCESS = 'POSITION_SUMMARY_GENERATOR_SUCCESS'
export const POSITION_SUMMARY_GENERATOR_FAIL = 'POSITION_SUMMARY_GENERATOR_FAIL'
